import * as Utils from './utils';

/**
 * getHtmlEm will return the em value of the document HTML.
 * @returns {Number|number}
 */
export function getHtmlEm(document) {
  return parseFloat(getComputedStyle(document.querySelector('html'))['font-size']) || 0;
}

/**
 * getImageStyleLeft will return the offset value for the CSS style 'left' to allow the image to stay the
 * image to stay centered in the viewport, without setting the image to a width equal to 100% of it's parent
 * container.
 * @returns {string}
 */
export function getImageStyleLeft(document, hasNavBar, imageId, screenWidthSmall, windowWidth) {
  const HTML_EM = Utils.getHtmlEm(document);
  const NAV_BAR_WIDTH = HTML_EM * 5;
  const IMAGE_WIDTH = Utils.getImageWidthById(document, imageId);
  const WINDOW_WIDTH = windowWidth || 0;
  let offset = 0;
  let viewport = 0;

  // If the window is large
  if (!screenWidthSmall) {
    // View port is the window width minus nav bar width divided by two (split sliders)
    viewport = (WINDOW_WIDTH - NAV_BAR_WIDTH) / 2;
    if (hasNavBar) {
      // If the this image is next to the nav bar, add the nav bar width to the offset to start the offset at the
      // appropriate x index.
      offset = ((viewport - IMAGE_WIDTH) / 2) + NAV_BAR_WIDTH;
    } else {
      // 'OverflowX' is set to hidden, the offset is only going to be to the left. Divide the pixel difference by
      // two and set that to the 'left' style, the other half will overflow to the right. Since this image is on
      // the right, do not add the nav bar width to the 'left' set value, since the nav bar is not part of the left
      // slider. Also, we should only be doing an offset if the image is larger than the viewport, the offset
      // should return a negative (left: -...), and there will always be an offset if the image is larger than the
      // viewport.
      offset = ((viewport - IMAGE_WIDTH) / 2);
    }
  } else {
    viewport = (WINDOW_WIDTH - NAV_BAR_WIDTH);
    offset = ((viewport - IMAGE_WIDTH) / 2) + NAV_BAR_WIDTH;
  }
  offset = (offset < 0) ? offset : offset - NAV_BAR_WIDTH;

  return offset.toString() + 'px';
}

/**
 * getImageWidthById will return the width of the image on the DOM return by the ID provided.
 * @returns {Number|number}
 */
export function getImageWidthById(document, imageId) {
  return document.getElementById(imageId).offsetWidth || 0;
}

/**
 * getWindowHeight will get the browser view window height.
 * @returns {Number|number}
 */
export function getWindowHeight(document) {
  return document.documentElement.clientHeight;
}

/**
 * getWindowWidth will get the browser view window width.
 * @returns {Number|number}
 */
export function getWindowWidth(document) {
  return document.documentElement.clientWidth;
}



// WEBPACK FOOTER //
// ./src/js/utils.js